import axios from "axios";
import type { LinkedInJobSearchDto, LinkedInJobResult } from "@reactive-resume/dto";

/**
 * Extract job description from a job URL
 */
export const extractJobDescription = async (url: string) => {
  try {
    const response = await axios.get("/api/jobs/extract-job-description", {
      params: { url },
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || "Failed to extract job description");
    }

    throw new Error("An error occurred while extracting the job description");
  }
};

/**
 * Search for jobs on LinkedIn
 */
export const searchLinkedInJobs = async (params: LinkedInJobSearchDto): Promise<LinkedInJobResult[]> => {
  try {
    const response = await axios.get<LinkedInJobResult[]>("/api/jobs/search-linkedin-jobs", {
      params,
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message || "Failed to search for jobs");
    }

    throw new Error("An error occurred while searching for jobs");
  }
};
